import { render, staticRenderFns } from "./sliderThumbs.vue?vue&type=template&id=ded7bafe&"
import script from "./sliderThumbs.vue?vue&type=script&lang=js&"
export * from "./sliderThumbs.vue?vue&type=script&lang=js&"
import style0 from "./sliderThumbs.vue?vue&type=style&index=0&lang=css&"
import style1 from "./sliderThumbs.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports